// extracted by mini-css-extract-plugin
export var assigneeBadge = "_it-0";
export var assigneeDetails = "_it-1";
export var assigneeInfo = "_it-2";
export var dropdownContainer = "_it-4";
export var dropdownImage = "_it-5";
export var editAssigneeInfo = "_it-3";
export var editAssigneeModalContainer = "_it-6";
export var hidden = "_it-8";
export var input = "_it-7";